export default {
  colors: {
    background: 'hsl(220 20% 7%)',
    card: 'hsl(220 20% 10%)',
    border: 'hsl(220 15% 18%)',

    primary: 'hsl(25 95% 53%)', // neon orange
    warm: 'hsl(30 80% 55%)',
    sky: 'hsl(190 90% 50%)', // neon cyan
    pink: 'hsl(330 85% 60%)',

    textColor: 'hsl(210 20% 92%)',
    mutedText: 'hsl(210 10% 55%)',

    // Backward-compatible keys used across the project
    orange: 'hsl(25 95% 53%)',
    green: 'hsl(220 20% 10%)',

    danger: {
      main: 'hsl(0 84% 60%)',
    },
  },
};
